import { stringUcFirst } from './stringUcFirst';

export const tableRowsValuesCOI = (
  candidates,
  committeeMembers,
  getCOIForCandidateAndMember,
  committeeName,
) => {
  const tableData = [];

  candidates.forEach((candidate) => {
    committeeMembers.forEach((member) => {
      const coiInfo = getCOIForCandidateAndMember(candidate.id, member.id);

      const memberDisplayName = member?.isChair
        ? `${member.name} (Chair)`
        : member.name;

      if (coiInfo.types || coiInfo.detail) {
        const formattedTypes = coiInfo.types.replace(/<br \/>/g, ', ');
        const coiTypesWithCategory = coiInfo.category
          ? `${formattedTypes}`
          : formattedTypes;

        tableData.push({
          candidateName: candidate.name,
          sectionalCommitteeId: committeeName,
          memberName: memberDisplayName,
          statusName: 'Complete',
          coiCategory: stringUcFirst(coiInfo.category || ''),
          coiTypes: coiTypesWithCategory,
          coiDetail: coiInfo.detail,
        });
      } else {
        tableData.push({
          candidateName: candidate.name,
          sectionalCommitteeId: committeeName,
          memberName: memberDisplayName,
          statusName: 'Incomplete',
          coiCategory: '',
          coiTypes: '',
          coiDetail: '',
        });
      }
    });
  });

  return tableData;
};
